import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import "virtual:uno.css"
// react-grid-layout's positioning styles (position/transition on .react-grid-item).
// It has to come **before** global.css — our overrides work by source order, and reversed they fail silently
import "react-grid-layout/css/styles.css"
import "./app/styles/global.css"
import { AppProvider } from "./app/providers/app-provider.js"
import { AppRoutes } from "./app/router.js"

const root = document.getElementById("root")
if (!root) throw new Error("#root is missing — index.html has been broken")

createRoot(root).render(
  <StrictMode>
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProvider>
  </StrictMode>,
)
